"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _reactSyntaxHighlighter = require("react-syntax-highlighter");
var _javascript = _interopRequireDefault(require("react-syntax-highlighter/dist/esm/languages/prism/javascript"));
var _json = _interopRequireDefault(require("react-syntax-highlighter/dist/esm/languages/prism/json"));
var _Code = _interopRequireDefault(require("./Code.styles"));
var _excluded = ["children", "language"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// NOTE: to help with bundle size we have limited the language to json/js
//    if you would like to add another language, import it and add a register
//    call below
var Code = function Code(_ref) {
  var children = _ref.children,
    language = _ref.language,
    props = _objectWithoutProperties(_ref, _excluded);
  // HOOKS
  var theme = (0, _styles.useTheme)();

  // MISC
  var cssCode = (0, _Code.default)(theme);
  switch (language) {
    case 'javascript':
      _reactSyntaxHighlighter.PrismLight.registerLanguage('javascript', _javascript.default);
      break;
    case 'json':
    default:
      _reactSyntaxHighlighter.PrismLight.registerLanguage('json', _json.default);
      break;
  }
  return /*#__PURE__*/_react.default.createElement(_reactSyntaxHighlighter.PrismLight, _extends({}, props, {
    language: language,
    style: cssCode
  }), children);
};
var _default = Code;
exports.default = _default;